var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-loader"},[_c('div',{staticClass:"modal-loader__container"},[_c('ui-loader',{attrs:{"variant":'gray'}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }